export default __webpack_public_path__ + "static/typography-image-b-6d2170c2186471d5038ea3f950875285.png";